import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../../actions';
import { clearFacePerson } from '../../../actions/Files';
import {
  hideFace,
  unhideFace,
} from '../../../actions/People';

import FilePersonName from '../PersonName';

import { isShare } from '../../../helpers/App';
import { userCanEditPeople } from '../../../helpers/Files';
import { eventDispatch } from '../../../helpers/Events';
import { sendTrackingEvent } from '../../../helpers';

const FileFacesItem = ({
  dispatch,
  face,
  file,
  readOnly,
}) => {
  const intl = useIntl();

  const openChangePersonModal = () => {
    dispatch(showModal('ChangePersonModal', {
      className: 'modal-change-person',
      face,
    }));
  };

  const handleClearPerson = () => {
    clearFacePerson(face.uuid);

    sendTrackingEvent('file-face-clear-person');
  };

  const handleSwitchFaceVibility = () => {
    if (face.hidden) {
      unhideFace(face.uuid);
      sendTrackingEvent('file-face-unhidden');
    } else {
      hideFace(face.uuid);
      sendTrackingEvent('file-face-hidden');
    }
    eventDispatch('faceUpdated', { ...face, hidden: !face.hidden });
  };

  const isEditPeopleAllowed = userCanEditPeople(file) && !readOnly;

  return (
    <div className="file-faces-element" id={face.uuid}>
      <div className="file-faces-element-thumbnail">
        <div className="file-faces-element-thumbnail-image" style={{ backgroundImage: `url(${face.image_path}` }} />
        {!face.person?.name && (
          <i className="fas fa-circle-exclamation file-faces-element-thumbnail-icon" />
        )}
      </div>
      <div className="file-faces-element-name">
        <FilePersonName
          face={face}
          file={file}
          readOnly={readOnly}
        />
      </div>
      {!isShare() && (
        <div className="file-faces-element-actions">
          <Link
            id={`person-${face.uuid}`}
            to={`/files?people=${face.person?.uuid}`}
            target="_blank"
          >
            <i className="far fa-images" />
          </Link>
          <UncontrolledTooltip fade={false} target={`person-${face.uuid}`}>
            {intl.formatMessage({ defaultMessage: 'View all images' })}
          </UncontrolledTooltip>
          {isEditPeopleAllowed && (
            <UncontrolledDropdown>
              <DropdownToggle nav>
                <i className="fas fa-ellipsis-h" />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={openChangePersonModal}
                >
                  <i className="far fa-user-viewfinder fa-fw" />
                  {face.person?.name ? (
                    intl.formatMessage({ defaultMessage: 'Change person' })
                  ) : (
                    intl.formatMessage({ defaultMessage: 'Select person' })
                  )}
                </DropdownItem>
                <DropdownItem
                  onClick={handleSwitchFaceVibility}
                >
                  {face.hidden ? (
                    <>
                      <i className="far fa-eye" />
                      {intl.formatMessage({ defaultMessage: 'Unhide face' })}
                    </>
                  ) : (
                    <>
                      <i className="far fa-eye-slash" />
                      {intl.formatMessage({ defaultMessage: 'Hide face' })}
                    </>
                  )}
                </DropdownItem>
                {face.person?.name && (
                  <DropdownItem
                    className="error"
                    onClick={handleClearPerson}
                  >
                    <i className="far fa-circle-half-stroke fa-rotate-by" style={{ '--fa-rotate-angle': '45deg' }} />
                    {intl.formatMessage({ defaultMessage: 'Clear' })}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          )}
        </div>
      )}
    </div>
  );
};

FileFacesItem.propTypes = {
  dispatch: PropTypes.func.isRequired,
  face: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

FileFacesItem.defaultProps = {
  readOnly: false,
};

export default connect()(FileFacesItem);
